export default "__VITE_ASSET__CO5tJKJQ__"